import { render, staticRenderFns } from "./AtomResults.vue?vue&type=template&id=37f1b5f4"
import script from "./AtomResults.vue?vue&type=script&lang=js"
export * from "./AtomResults.vue?vue&type=script&lang=js"
import style0 from "./AtomResults.vue?vue&type=style&index=0&id=37f1b5f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports